import { toast } from 'react-toastify';
import { loginFail, loginSuccess, logout } from '../redux/actions/authActions';
import api from '../api/index';
import { loadingStartAction, loadingStopAction } from 'src/redux/actions/loadingActions';

// Thunk for login
export const login = (username, password) => async (dispatch) => {
  if (!username || !password) {
    toast.error('Please enter your phone and password');
    return false;
  }

  dispatch(loadingStartAction());

  try {
    const response = await api.post('/users/login', { email: username, password });

    if (!response.data?.isAdmin) {
      toast.error('You are not authorized to use the dashboard.');
      dispatch(loginFail());
      return false;
    }

    // The API returns the user fields and the token in one flat object, so
    // there is no nested "user" key to destructure. Reading one made the
    // stored user permanently undefined.
    const { token, ...user } = response.data;

    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(user));

    dispatch(loginSuccess(token, user));
    return true;
  } catch (error) {
    // The response interceptor already surfaced the reason.
    dispatch(loginFail());
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    return false;
  } finally {
    dispatch(loadingStopAction());
  }
};

export const logoutUser = () => (dispatch) => {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
  dispatch(logout());
};
